import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1c142ba2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "info-warp"
};
const _hoisted_2 = {
  key: 0,
  class: "cover"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "detail"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "main"
};
const _hoisted_7 = {
  class: "introduce"
};
const _hoisted_8 = {
  class: "introduce-content"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':وُلِدّ'), -1));

const _hoisted_10 = {
  class: "introduce-content"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':تاريخ الميلاد'), -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':الجوائز'), -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':سيرة شخصية'), -1));

const _hoisted_14 = {
  class: "introduce-content"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':المهنية'), -1));

const _hoisted_16 = {
  class: "operation"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "recommend-warp"
};
const _hoisted_19 = {
  class: "tabs"
};
const _hoisted_20 = ["element-loading-background"];
const _hoisted_21 = {
  class: "year"
};
const _hoisted_22 = {
  key: 1,
  class: "biography-info"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, /*#__PURE__*/_toDisplayString('سيرة شخصية'), -1));

const _hoisted_24 = {
  class: "info"
};
import ElTabs from '../../../components/ElTabs/index.vue';
import MoviesOrActorItem from './moviesOrActorItem.vue';
import OtherMOAItem from './otherMOAItem.vue';
import DetailDialog from './detailDialog.vue';
import { inject, onMounted } from 'vue';
import { getAwardsApi, getBiographyApi, getCastOrDirectorDetailApi, getVodListByTypeApi } from '@/api/vodPlus';
export default /*#__PURE__*/_defineComponent({
  __name: 'castOrDirectorDetail',
  props: {
    nameId: {
      type: [String, Number],
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const operationBtnList = ref([{
      url: require('../../images/icon_favourite.png'),
      selUrl: require('../../images/icon_favourite_sel.png')
    }]);
    const dataConfig = reactive({
      params: {
        start: 0,
        total: 7,
        type: 1 // 1. movies 2.series 3. record

      },
      loading: false,
      recommendLoading: false,
      dialogLoading: false
    });
    const tabList = ref([{
      name: 'Movies',
      id: 1
    }, {
      name: 'Series',
      id: 2
    }]);
    const dataList = ref([]);
    const awardList = ref([]);
    const biographyData = ref(''); // 详情内容对象

    const detailInfo = ref({});

    const getData = async () => {
      dataConfig.params.type = 1;
      dataConfig.loading = true;

      try {
        let nameId;
        nameId = props.nameId ? props.nameId : currentParams.value.nameId;
        const res = await getCastOrDirectorDetailApi({
          nameId
        });
        console.log(res);

        if (res.status == 200) {
          detailInfo.value = res.data;
          dataConfig.loading = false;
        } else {
          dataConfig.loading = false;
        }
      } catch (error) {
        if (error.message !== 'canceled') {
          dataConfig.recommendLoading = false;
        }
      }
    };

    const awardConfig = reactive({
      visible: false,
      action: ''
    });

    const onAwardsClick = () => {
      awardConfig.action = 'award';
      awardConfig.visible = true;
      getAwards();
    };

    const onBiographyClick = () => {
      awardConfig.action = 'biography';
      awardConfig.visible = true;
      getBiography();
    };

    const handleTabClick = item => {
      // console.log(item)
      dataConfig.params.type = item.props.name;
      getVodListByType();
    };

    const getAwards = async () => {
      awardList.value = [];
      dataConfig.dialogLoading = true;

      try {
        let nameId;
        nameId = props.nameId ? props.nameId : currentParams.value.nameId;
        const res = await getAwardsApi({
          nameId
        });
        console.log(res);

        if (res.status == 200) {
          awardList.value = res.data;
        }
      } catch (error) {}

      dataConfig.dialogLoading = false;
    };

    const getBiography = async () => {
      biographyData.value = '';
      dataConfig.dialogLoading = true;

      try {
        let nameId;
        nameId = props.nameId ? props.nameId : currentParams.value.nameId;
        const res = await getBiographyApi({
          nameId
        });
        console.log(res);

        if (res.status == 200) {
          biographyData.value = res.data;
        }
      } catch (error) {}

      dataConfig.dialogLoading = false;
    };

    const getVodListByType = async () => {
      dataConfig.recommendLoading = true;

      try {
        let nameId;
        nameId = props.nameId ? props.nameId : currentParams.value.nameId;
        const res = await getVodListByTypeApi({ ...dataConfig.params,
          nameId
        });
        console.log('getVodListByType', res);

        if (res.status == 200) {
          dataList.value = res.data.list.map(item => {
            return { ...item,
              type: dataConfig.params.type == 1 ? 'movie' : 'series'
            };
          });
          dataConfig.recommendLoading = false;
        } else {
          dataConfig.recommendLoading = false;
        }
      } catch (error) {
        if (error.message !== 'canceled') {
          dataConfig.recommendLoading = false;
        }
      }
    };

    const itemClick = item => {
      emit('onCardClick', item);
    };

    onMounted(async () => {
      const previewWarp = document.querySelector('.preview-warp');
      previewWarp.scrollTo(0, 0);
      await getData();
      getVodListByType();
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_empty = _resolveComponent("el-empty");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["cast-director-detail", _unref(currentUiStyleOptions).class]),
        "element-loading-background": "transparent"
      }, [!dataConfig.loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_1, [_unref(currentUiStyleOptions).showImg ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
        src: __props.image || _unref(currentParams).image,
        alt: ""
      }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(__props.name || _unref(currentParams).name), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_unref(currentUiStyleOptions).styleName == 'default' || _unref(currentUiStyleOptions).styleName == 'arabic' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_8, _toDisplayString(_unref(detailInfo).born), 1), _hoisted_9]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString(_unref(detailInfo).dateOfBirth), 1), _hoisted_11]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            onClick: onAwardsClick,
            class: "introduce-content color-text"
          }, _toDisplayString(_unref(detailInfo).awards), 1), _hoisted_12]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            onClick: onBiographyClick,
            class: "introduce-content color-text"
          }, _toDisplayString(_unref(detailInfo).biography), 1), _hoisted_13]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_14, _toDisplayString(_unref(detailInfo).profession), 1), _hoisted_15]),
          _: 1
        })]),
        _: 1
      })], 64)) : _createCommentVNode("", true), _unref(currentUiStyleOptions).styleName == 'style2' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Date Of Birth')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_unref(detailInfo).dateOfBirth), 1)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Profession')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_unref(detailInfo).profession), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Born')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_unref(detailInfo).born), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Awards')) + ": ", 1), _createElementVNode("span", {
            onClick: onAwardsClick,
            class: "color-text"
          }, _toDisplayString(_unref(detailInfo).awars), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Biography')) + ": ", 1), _createElementVNode("span", {
            onClick: onBiographyClick,
            class: "color-text"
          }, _toDisplayString(_unref(detailInfo).biography), 1)]),
          _: 1
        })]),
        _: 1
      })], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operationBtnList.value, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: "span-item pointer",
            key: index
          }, [_createElementVNode("img", {
            src: item.selUrl,
            alt: ""
          }, null, 8, _hoisted_17)]);
        }), 128))]),
        _: 1
      })])])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(ElTabs, {
        "tab-lists": tabList.value,
        "tab-active-name": dataConfig.params.type,
        onOnTabClick: handleTabClick
      }, null, 8, ["tab-lists", "tab-active-name"])]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "recommend-list",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [_unref(currentUiStyleOptions).styleName == 'default' || _unref(currentUiStyleOptions).styleName == 'arabic' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [dataList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(dataList.value, (item, index) => {
        return _openBlock(), _createBlock(MoviesOrActorItem, {
          onClick: $event => itemClick(item),
          poster: item.poster,
          "program-name": item.programName
        }, null, 8, ["onClick", "poster", "program-name"]);
      }), 256)) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      }))], 64)) : _createCommentVNode("", true), _unref(currentUiStyleOptions).styleName == 'style2' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [dataList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(dataList.value, (item, index) => {
        return _openBlock(), _createBlock(OtherMOAItem, {
          onClick: $event => itemClick(item),
          infoItem: item
        }, null, 8, ["onClick", "infoItem"]);
      }), 256)) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      }))], 64)) : _createCommentVNode("", true)], 8, _hoisted_20)), [[_directive_loading, dataConfig.recommendLoading]])])], 64)) : _createCommentVNode("", true), _createVNode(DetailDialog, {
        modelValue: awardConfig.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => awardConfig.visible = $event)
      }, {
        content: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [awardConfig.action == 'award' ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(awardList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "award-info",
            key: index
          }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", null, _toDisplayString(item.year), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.awards, (award, awardIndex) => {
            return _openBlock(), _createElementBlock("div", {
              class: "award",
              key: awardIndex
            }, [_createElementVNode("p", null, _toDisplayString(award), 1)]);
          }), 128))]);
        }), 128)) : _createCommentVNode("", true), awardConfig.action == 'biography' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("p", _hoisted_24, _toDisplayString(biographyData.value), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, dataConfig.dialogLoading]])]),
        _: 1
      }, 8, ["modelValue"])], 2)), [[_directive_loading, dataConfig.loading]]);
    };
  }

});